import { FC, useEffect } from "react";

import styles from "./Widget.module.css";
import { TabbedWidget } from "@components/TabbedWidget/TabbedWidget";
import { darkenColor } from "@utils/colorUtils";

interface WidgetProps {
  productArticle: string;
  baseColor?: string;
  productName?: string;
  clientId?: string;
}

export const Widget: FC<WidgetProps> = ({ productArticle, baseColor, productName }) => {
  useEffect(() => {
    if (baseColor) {
      // Set the primary color
      document.documentElement.style.setProperty("--color-primary", baseColor);

      // Calculate and set the darkened version for --color-primary-dark
      const darkerColor = darkenColor(baseColor);
      document.documentElement.style.setProperty(
        "--color-primary-dark",
        darkerColor
      );
    }
  }, [baseColor]);

  return (
    <div className={styles.container}>
      <TabbedWidget productArticle={productArticle} productName={productName} />
    </div>
  );
};
